<template>
    <div>
        <div>{{ title }}</div>
        <div class="mb-0 fs-3 fw-bold">{{ value }}</div>
    </div>
</template>

<script>
export default {
    name: "FormPreviewField",
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
